import { base64ToBytes, bytesToBase64 } from './utils';

interface EncryptedData {
  ciphertext: string;
  iv: string;
  version: number;
}

export async function encrypt(
  plaintext: string,
  key: Uint8Array
): Promise<string> {
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const encoded = new TextEncoder().encode(plaintext);

  const cryptoKey = await crypto.subtle.importKey(
    'raw',
    key.buffer as ArrayBuffer,
    { name: 'AES-GCM' },
    false,
    ['encrypt']
  );

  const ciphertext = await crypto.subtle.encrypt(
    { name: 'AES-GCM', iv },
    cryptoKey,
    encoded
  );

  const data: EncryptedData = {
    ciphertext: bytesToBase64(new Uint8Array(ciphertext)),
    iv: bytesToBase64(iv),
    version: 1,
  };

  return btoa(JSON.stringify(data));
}

export async function decrypt(
  encryptedString: string,
  key: Uint8Array
): Promise<string> {
  const data: EncryptedData = JSON.parse(atob(encryptedString));

  const iv = base64ToBytes(data.iv);
  const ciphertext = base64ToBytes(data.ciphertext);

  const cryptoKey = await crypto.subtle.importKey(
    'raw',
    key.buffer as ArrayBuffer,
    { name: 'AES-GCM' },
    false,
    ['decrypt']
  );

  const decrypted = await crypto.subtle.decrypt(
    { name: 'AES-GCM', iv: iv.buffer as ArrayBuffer },
    cryptoKey,
    ciphertext.buffer as ArrayBuffer
  );

  return new TextDecoder().decode(decrypted);
}
